module.exports = __webpack_public_path__ + "img/slide2.6e34c882.png";